import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconDrillingPartRightStrokedSizeM from './IconDrillingPartRightStroked_size_m';
import IconDrillingPartRightStrokedSizeS from './IconDrillingPartRightStroked_size_s';
import IconDrillingPartRightStrokedSizeXs from './IconDrillingPartRightStroked_size_xs';

const props: CreateIconArguments = {
  l: IconDrillingPartRightStrokedSizeM,
  m: IconDrillingPartRightStrokedSizeM,
  s: IconDrillingPartRightStrokedSizeS,
  xs: IconDrillingPartRightStrokedSizeXs,
  name: 'IconDrillingPartRightStroked',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'mono',
};

export default props;
